import { Component, TemplateRef, ViewChild } from '@angular/core';
import { INgSelectTemplate } from '@shared/modules/form-components/select/classes/INgSelectTemplate';

@Component({
  selector: 'app-reject-candidate-selection-option-template',
  templateUrl: './reject-candidate-selection-option-template.component.html',
  styleUrls: ['./reject-candidate-selection-option-template.component.scss'],
})
export class RejectCandidateSelectionOptionTemplateComponent implements INgSelectTemplate {
  @ViewChild(TemplateRef, { static: true, read: TemplateRef })
  templateRef: TemplateRef<HTMLElement>;
}
